import NestedMenu from "components/Shared/NestedMenu";
import React from "react";

const VendorStaffSidebar = () => {
  const menuItems = [
    {
      title: "Dashboard",
      path: "/app/staff/dashboard",
      icon: "DashboardOutlined",
    },
    {
      title: "Shipment",
      path: "/app/staff/shipment/list",
      icon: "GroupWorkOutlined",
    },
        {
      title: "Tickets",
      icon: "ConfirmationNumberOutlined",
      path: "/app/staff/ticket/list",
    },
    {
      title: "Announcement",
      path: "/app/staff/announcement/list",
      icon: "CampaignOutlined",
    },
    
  ];

  return (
    <NestedMenu menu={menuItems} initiallyOpenedMenu="Vendor Management" />
  );
};

export default VendorStaffSidebar;
